export default __webpack_public_path__ + "8a13b60f562a559a81180df726395662.gif";